<template>
    <div class="af_root_div">
        <div id="page-header">
            <div class="bluebar head_logo"></div>
            <div>{{$t("message")["HealthHome.hr"]}}&nbsp;&nbsp;&nbsp;&nbsp;{{ data_date }}</div>
            <a-date-picker id="date_picker" @change="ChangeDataDate"></a-date-picker>
        </div>
        <div id="scatter-chart">
        </div>
        <div id="diagnose_div">
            <div id="diagnose_title">{{ $t("message")["AtrialData.diagnosis"] }}:</div>
            <div id="diagnose_conclusion">{{todayAfResult}}</div>
            <div id="diagnose_disclaimer">{{ $t("message")["AtrialData.disclaimer"] }}</div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import echarts from 'echarts'
import domain from "../../domain";
import request from "../../utils/request";
import JSZip from "jszip";
import {extendHeadTail,maxNumber,maxNumberSum,extractLastComponentFromUrl} from "../../utils/toolbox.js"
const moment = require('moment');

var scatter_chart
var time_chart
var heart_chart
var day_chart
export default {
    data() {
        return {
            deviceId:'',
            data_date:"",
            todayStr:'',
            dateValue: '',
            device_type: 1,
            uid: "",            
            timeValue: '',
            scatterValue: [],
            afTimeValue: [],
            sevenDayTestTime: [],
            sevenDayAfTime: [],
            showLoading: false,
            level4List: [],
            level3List: [],
            level2List: [],
            level1List: [],
            maxHrList: [],
            downloadUrl:'',
            latesthr:'-',
            todayAfResult:this.$t("message")["AtrialData.noresult"],
            allResult:"",//文件的结果信息
            datestr:"",//日期
        };
    },
    watch: {
        "$store.state.windowWidth": function() {
            var w = this.$store.state.windowWidth
            document.getElementById('scatter-chart').style.width = w * 0.3
            document.getElementById('time-chart').style.width = w * 0.5
            document.getElementById('heart-chart').style.width = w * 0.5
            document.getElementById('day-chart').style.width = w * 0.5
            scatter_chart.resize()
            time_chart.resize()
            heart_chart.resize()
            day_chart.resize()
        }
    },
    methods: {
        drawScatterChart() {
            var myChart = echarts.init(document.getElementById('scatter-chart'));
            myChart.setOption({
                title: {
                    text: this.$t("message")["AtrialData.chart_title"],
                    textStyle:{
                        color :'#727272',
                        fontSize :'14'
                    }
                },
                xAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                                type: 'dashed'
                        }
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: '#999999',
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    axisLabel: {
                        fontSize: 12,
                        color: '#999999',
                    }
                },
                series: [{
                    symbolSize: 2,
                    data: this.scatterValue,
                    type: 'scatter',
                    itemStyle: {
                        color: '#4D282828'
                    }
                }]
            });
            scatter_chart = myChart
        },

        loadScatterData(deviceid,datestr){
            //show loading... since data load time is long
            this.showLoading = true;
            //if data load still not finish, close loading... after 10 seconds
            setTimeout(() => {
                this.showLoading = false;
            }, 6000);

            this.scatterValue.splice(0,this.scatterValue.length);

            let afUrl = domain.URLS.AF_RESULT+'/'+datestr.substring(0,10)+"/"+deviceid+"-"+datestr.substring(0,10)+'.txt'

            this.downloadUrl = afUrl
            let that = this;
            request({
                url: afUrl,
                methods: "GET"
            }).then(function(response){
                that.showLoading = false;
                if(response.status==200 && response.data != null){
                    let rrilist = []
                    let jstrlist = response.data.split(/\r?\n/)
                    jstrlist.pop()
                    for(let i in jstrlist){
                        let logobj = JSON.parse(jstrlist[i])
                        let rristrlist = logobj["message"].split(',')
                        for(let j in rristrlist){
                            let val = parseInt(rristrlist[j])
                            rrilist.push(val)
                        }
                    }
                    for(let i=0;i<rrilist.length-1;i++){
                        if((rrilist[i]>=200 && rrilist[i]<=2000) && (rrilist[i+1]>=200 && rrilist[i+1]<=2000)){
                            that.scatterValue.push([rrilist[i],rrilist[i+1]])
                        }
                    }
                    that.drawScatterChart()
                }
                else {
                    that.drawScatterChart()
                }
            }).catch(function(response) {
                that.showLoading = false;

                that.scatterValue.splice(0,that.scatterValue.length);
                that.drawScatterChart()
            })
        },
        loadAfstatValue(deviceid,date_str) {
            var url = domain.URLS.AtrialFibration_24hoursUrl+"?deviceid="+deviceid+
                "&recordate="+date_str
            let that = this;
            request({
                url: url,
                methods: "GET"
            }).then(function(response){
                if(response.data != null && response.data.ReturnCode==0){
                    that.afTimeValue.splice(0,that.afTimeValue.length)
                    var afstrlist = response.data.Data.split(',')
                    for(var j in afstrlist){
                        var val = parseInt(afstrlist[j])
                        that.afTimeValue.push(val)
                    }
                    that.drawTimeBarChart();
                }
                that.loadAfstat7dayValue();
            })
        },
        loadAfstat7dayValue() {
            var url = domain.URLS.AtrialFibration_7daysUrl+"?deviceid="+this.deviceId+"&recordate="
                +this.datestr
            let that = this;
            request({
                url: url,
                methods: 'GET'
            }).then(function(response){
                if(response.data != null && response.data.ReturnCode==0){
                    that.sevenDayTestTime.splice(0,that.sevenDayTestTime.length)
                    that.sevenDayAfTime.splice(0,that.sevenDayAfTime.length)
                    var afobjlist = response.data.Data
                    for(let j in afobjlist){
                        let aftimestr = afobjlist[j]["AFTime"]
                        let testimestr = afobjlist[j]["TestTime"]
                        let aftimestrlist = aftimestr.split(',')
                        let testimestrlist = testimestr.split(',')
                        let aftime = 0
                        let testime = 0
                        for(let k in aftimestrlist){
                            let val = parseInt(aftimestrlist[k])
                            aftime = aftime + val
                            val = parseInt(testimestrlist[k])
                            testime = testime + val
                        }
                        that.sevenDayAfTime.push(aftime)
                        if(aftime>0 && testime==0){
                            that.sevenDayTestTime.push(aftime)
                        }
                        else
                        that.sevenDayTestTime.push(testime)
                    }
                    that.drawDayBarChart();
                }
            })
        },

        loadHistoryData(){
            this.datestr = this.dateValue
            this.loadScatterData(this.deviceId,this.datestr);
            this.loadAfstatValue(this.deviceId,this.datestr)
            this.loadWholeDayAfResult(this.deviceId,this.datestr);
        },
        loadTodayScatter(){
            this.datestr = this.todayStr
            this.loadScatterData(this.deviceId,this.datestr);
            this.loadAfstatValue(this.deviceId,this.datestr)
            this.loadWholeDayAfResult(this.deviceId,this.datestr);
        },
        loadWholeDayAfResult(deviceid,date_str) {
            var url = domain.URLS.Get_Today_Af_Result+"?deviceid="+deviceid+
                "&recordate="+date_str
            let that = this;
            request({
                url: url,
                methods: "GET"
            }).then(function(response){
                console.log('-----------af response.data:',response.data);
                if(response.data != null && response.data.ReturnCode==0){
                    if (response.data.Data == 0) {
                        that.todayAfResult = that.$t("message")["AtrialData.noresult"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else if(response.data.Data == 1){
                        that.todayAfResult = that.$t("message")["AtrialData.SINUS_HR"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else if(response.data.Data == 2){
                        that.todayAfResult = that.$t("message")["AtrialData.SINUS_BRADYCARDIA"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else if(response.data.Data == 3){
                        that.todayAfResult = that.$t("message")["AtrialData.SINUS_TACHYCARDIA"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else if(response.data.Data == 4){
                        that.todayAfResult = that.$t("message")["AtrialData.SINUS_ARRHYTHMIA"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else if(response.data.Data == 5){
                        that.todayAfResult = that.$t("message")["AtrialData.SINUS_ATRIAL_FIBRILLATION"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else if(response.data.Data == 6){
                        that.todayAfResult = that.$t("message")["AtrialData.SINUS_SUPRAVENTRICULAR_TACHYCARDIA"] + that.$t("message")["AtrialData.scatter.desc"]
                    } else {
                        that.todayAfResult = that.$t("message")["AtrialData.normal"] + that.$t("message")["AtrialData.scatter.desc"]
                    }
                } else {
                    that.todayAfResult = that.$t("message")["AtrialData.nodata"]
                }
            })
        },

        loadAfDataOfUser(uid,date_str) {
            let reqUrl = domain.URLS.AF_BLE_RESULT;
            let reqParams = {
                uid: uid,
                record_date: date_str
            };
            let that = this;
            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            }).then(function(response){
                if(response.data != null && response.data.ReturnCode==0){
                    that.downloadRriFile(response.data.Data.af_rri_url);
                    if (response.data.Data.af_ai_result == 0) {
                        that.todayAfResult = that.$t("message")["AtrialData.normal"]
                    } else {
                        that.todayAfResult = that.$t("message")["AtrialData.abnormal"]
                    }
                } else {
                    that.todayAfResult = that.$t("message")["AtrialData.nodata"]
                }
            })
        },
        async downloadRriFile(fileUrl){
            try {
                const response = await request({
                    url: fileUrl,
                    methods: "GET",
                    responseType: "arraybuffer", // Important for binary data like zip files
                });
                const zip = new JSZip();
                const zipFile = await zip.loadAsync(response.data);
                zipFile.forEach(async (relativePath, zipObject) => {
                    const fileContent = await zipObject.async("text");
                    this.proceedZipRriFile(fileContent);
                });
            } catch (error) {
                console.error("Error:", error);
            }
            
        },
        proceedZipRriFile(content) {
            this.scatterValue.splice(0,this.scatterValue.length);
            var rrilist = [];
            let rristrlist = JSON.parse(content);
            for(let j in rristrlist){
                let val = parseInt(rristrlist[j])
                rrilist.push(val)
            }
            for(let i=0;i<rrilist.length-1;i++){
                if((rrilist[i]>=200 && rrilist[i]<=2000) && (rrilist[i+1]>=200 && rrilist[i+1]<=2000)){
                    this.scatterValue.push([rrilist[i],rrilist[i+1]])
                }
            }
            this.drawScatterChart()
        },
        ChangeDataDate(val){
            let date_str = val.format('YYYY-MM-DD');
            this.data_date = date_str;
            if(this.device_type == 2){
                this.loadAfDataOfUser(this.uid,this.data_date);
            }else{
                this.loadScatterData(this.deviceId,this.data_date);
                this.loadWholeDayAfResult(this.deviceId,this.data_date);
            }
        }
    },
    mounted: function(){
        this.device_type = sessionStorage.getItem("device_type");
        this.deviceId = sessionStorage.getItem("deviceid");
        this.data_date = this.$route.params.data_date;
        console.log('data_date:',this.data_date);
        if(this.device_type == 2){
            this.uid = sessionStorage.getItem("uid");
            this.loadAfDataOfUser(this.uid,this.data_date);
        }else{
            this.loadScatterData(this.deviceId,this.data_date);
            this.loadWholeDayAfResult(this.deviceId,this.data_date);
        }
    }
}
</script>

<style scoped lang="scss">
.af_root_div {
    padding-bottom: 10px;
    position: relative;
    left: 0px;
    border: 1px solid white;
}

#page-header {
    height: 50px;
    font-size: 16px;
    color: #292929;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: bold;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-left: 15px;
    padding-right: 15px;
}

.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.head_logo {
    margin-right: 10px;
}

#date_picker {
    margin-left: auto;
}

#loading {
  display: flex;
  justify-content: center; /* Horizontally center */
  align-items: center; /* Vertically center */
}

#scatter-chart {
    height: 400px;
    margin-left: 20px;
    margin-right: 20px;
}

#diagnose_div {
    display: flex;
    flex-direction: column;
    height: 200px;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
    background-color: #FCFCFC;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
}

#diagnose_title {
    color: #454545;
    font-weight: bold;
    font-size: 16px;
    height: 50px;
    margin-top: 20px;
    margin-left: 20px;
    margin-right: 20px;
}

#diagnose_conclusion {
    color: #505050;
    font-size: 14px;
    flex: 1;
    margin-left: 20px;
    margin-right: 20px;
}

#diagnose_disclaimer {
    color: #999999;
    font-size: 12px;
    height: 50px;
    margin-left: 20px;
    margin-right: 20px;
}
</style>